// import React from 'react';
// import PropTypes from 'prop-types';
// import UserModal from '../molecules/user-modal/user-modal';
// import { connect } from 'react-redux';
// import { WithMember, ClientSideOnly } from '@quintype/components';
// import StoryPayment from '../story/story-paywall/story-payment';
// import { PATH } from '../../constants';
// import Loader from '../atoms/icons/loader';

// const userModalStateToProps = state => ({
// publicIntegrations: state.qt.config['public-integrations'] || {},
// integrations: state.qt.config.integrations || {}
// });

// const WrappedUserModal = connect(
// userModalStateToProps,
// {}
// )(UserModal);

// function returnUrl() {
// return new URL(global.window.location).searchParams.get('returnUrl');
// }

// function currentScreen() {
// return new URL(global.window.location).searchParams.get('currentScreen');
// }

// function redirectToReturnUrl() {
// global.window.location = returnUrl() || '/';
// }

// function LoadingIndicator() {
// return (
// <div className="loader">
// <Loader color={'#000'} />
// </div>
// );
// }

// class StoryPaymentIfNoAccess extends React.Component {
// constructor(props) {
// super(props);
// this.state = { loaded: false };
// }

// async componentDidMount() {
// const hasAccess = global.AccessType && (await global.AccessType.hasAccess(this.props.story.id));
// if (hasAccess) {
// redirectToReturnUrl();
// } else {
// this.setState({ loaded: true });
// }
// }

// render() {
// if (this.state.loaded) {
// return <StoryPayment {...this.props} />;
// } else {
// return <LoadingIndicator />;
// }
// }
// }

// StoryPaymentIfNoAccess.propTypes = {
// story: PropTypes.object
// };

// export function AmpLogin({ data }) {
// return (
// <ClientSideOnly serverComponent={LoadingIndicator}>
// <WithMember>
// {({ member, isLoading, checkForMemberUpdated }) =>
// isLoading && !member ? <LoadingIndicator /> : showDialog(member, checkForMemberUpdated)
// }
// </WithMember>
// </ClientSideOnly>
// );

// function showDialog(member, checkForMemberUpdated) {
// if (!member) {
// return (
// <WrappedUserModal
// currentScreen={currentScreen()}
// isAmpPage={true}
// onComplete={member => (member ? checkForMemberUpdated() : redirectToReturnUrl())}
// />
// );
// } else {
// return (
// <StoryPaymentIfNoAccess
// story={data.story}
// updateAccess={redirectToReturnUrl}
// subscribeUrl={`${PATH.SUBSCRIPTION_PAGE}?returnUrl=${encodeURIComponent(returnUrl())}`}
// />
// );
// }
// }
// }

// AmpLogin.propTypes = {
// data: PropTypes.object
// };

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ClientSideOnly } from '@quintype/components';
import { connect } from 'react-redux';
import Loader from '../atoms/icons/loader';
import { PATH } from '../../constants';

function LoadingIndicator() {
  return (
    <div className="loader">
      <Loader color={'#000'} />
    </div>
  );
}
class AmpPageBase extends Component {
  componentDidMount() {}

  render() {
    return (
      <ClientSideOnly serverComponent={LoadingIndicator}>
        <LoadingIndicator />
      </ClientSideOnly>
    );
  }
}

AmpPageBase.propTypes = {
  data: PropTypes.object,
  publicIntegrations: PropTypes.objectOf(PropTypes.any).isRequired,
  integrations: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = (state) => ({
  publicIntegrations: state.qt.config['public-integrations'] || {},
  integrations: state.qt.config.integrations || {},
});

const AmpLogin = connect(mapStateToProps, null)(AmpPageBase);

export { AmpLogin };
